import { EnumWithDescription, ICustomEnumValue } from "./EnumWithDescription";

export enum PalReferralTabsEnum {
    Demographics = 1 as any,
    PayerTab = 2 as any,
    ClinicalInformation = 3 as any,
    HealthHistory = 4 as any,
    Providers = 5 as any,
    PharmacyAndDme = 6 as any,
    AuthorizedContacts = 7 as any,
    EmergencyPreparedness = 8 as any,
    AdvanceDirectives = 9 as any,
    PatientGoals = 10 as any,
    ReferralInformation = 11 as any,
    PatientNotes = 12 as any,
    MyNotes = 13 as any
}
class PalReferralTabsClass extends EnumWithDescription<PalReferralTabsEnum> {
    public readonly enum = PalReferralTabsEnum;
    public readonly enumName: string = "PalReferralTabs";

    public readonly enumWithDescriptions: Map<string, ICustomEnumValue<PalReferralTabsEnum>> = new Map([
        [
            "Demographics",
            {
                value: PalReferralTabsEnum.Demographics,
                name: "demographics"
            }
        ],
        [
            "PayerTab",
            {
                value: PalReferralTabsEnum.PayerTab,
                name: "payertab"
            }
        ],
        [
            "ClinicalInformation",
            {
                value: PalReferralTabsEnum.ClinicalInformation,
                name: "clinicalinformation"
            }
        ],
        [
            "HealthHistory",
            {
                value: PalReferralTabsEnum.HealthHistory,
                name: "healthhistory"
            }
        ],
        [
            "Providers",
            {
                value: PalReferralTabsEnum.Providers,
                name: "providers"
            }
        ],
        [
            "PharmacyAndDme",
            {
                value: PalReferralTabsEnum.PharmacyAndDme,
                name: "pharmacyanddme"
            }
        ],
        [
            "AuthorizedContacts",
            {
                value: PalReferralTabsEnum.AuthorizedContacts,
                name: "authorizedContacts"
            }
        ],
        [
            "EmergencyPreparedness",
            {
                value: PalReferralTabsEnum.EmergencyPreparedness,
                name: "emergencypreparedness"
            }
        ],
        [
            "AdvanceDirectives",
            {
                value: PalReferralTabsEnum.AdvanceDirectives,
                name: "advanceDirectives"
            }
        ],
        [
            "PatientGoals",
            {
                value: PalReferralTabsEnum.PatientGoals,
                name: "patientgoals"
            }
        ],
        [
            "ReferralInformation",
            {
                value: PalReferralTabsEnum.ReferralInformation,
                name: "referralinformation"
            }
        ],
        [
            "PatientNotes",
            {
                value: PalReferralTabsEnum.PatientNotes,
                name: "patientnotes"
            }
        ],
        [
            "MyNotes",
            {
                value: PalReferralTabsEnum.MyNotes,
                name: "mynotes"
            }
        ]
    ]);
}

export const PalReferralTabs = new PalReferralTabsClass();
